import { isValidDateValue } from '@testing-library/user-event/dist/utils';
import vest, { test, enforce } from 'vest';
import any from 'vest/any';
import { ContentForm } from './content.form.types';
import { validateCastCrewList } from '@lib/common/cast-crew-validation.utils';

const requiredText = enforce.template(enforce.isString().isTruthy());

export const contentValidationSuite = vest.create((content: Partial<ContentForm> = {}) => {
  if (content.title || content.original_title == '') {
    test('title', 'Title or original title is required', () => {
      requiredText(content.title);
    });
  }
  if (content.content_type === null) {
    test('content_type', 'Content type is required', () => {
      requiredText(content.content_type);
    });
  }
  if(content.cast_crew){
    test('role_manadatory', 'Role is required for each member', () => {
      const validCastCrew = content.cast_crew.filter(x => x && Object.keys(x).length > 0);
      const roles = validCastCrew.map(x => x.role).filter(e => e);
      const vtr_ids = validCastCrew.map(x => x.vtr_id);
      enforce(roles.length === vtr_ids.length).isTruthy();
    });

    test('cast_crew_duplicates', () => {
      const validation = validateCastCrewList(content.cast_crew);
      if (!validation.isValid) {
        // Use the detailed error message from the validation utility
        enforce(false).isTruthy();
      }
    });
  }

  if (content.filming_start_date) {
    test("", "Filming Start date is not valid", () => {
      enforce(isDateValid(content.filming_start_date)).isTruthy();
    })
  }

  if (content.filming_end_date) {
    test("", "Filming End date is not valid", () => {
      enforce(isDateValid(content.filming_end_date)).isTruthy();
    })
  }

  if (content.filming_start_date && content.filming_end_date) {
    test('filming_end_date', 'Filming end date should be after start date', () => {
      const startDate = new Date(content.filming_start_date);
      const endDate = new Date(content.filming_end_date);
      enforce(endDate > startDate).isTruthy();
    });
  }

  if (content.first_air_date && content.last_air_date) {
    test('filming_end_date', 'Last Aired Date should be after start date', () => {
      const startDate = new Date(content.first_air_date);
      const endDate = new Date(content.last_air_date);
      enforce(endDate >= startDate).isTruthy();
    });
  }

  if (content.release_date) {
    test('release_date', 'Release date is not valid. Use DD/MM/YYYY (e.g. 12/08/2026).', () => {
      enforce(isDateValid(content.release_date)).isTruthy();
    });
  }

   //TODO: removed temp.
  // if (content?.revenue) {
  //   const contentRaw = content?.revenue ?? null;
  //   const isString = typeof contentRaw === 'string';
  //   const isNumericString = isString && /^-?\d+(\.\d+)?$/.test(contentRaw);
  //   const numericValue = isNumericString ? parseFloat(contentRaw) : contentRaw;

  //   const shouldValidate =
  //     numericValue === null ||
  //     typeof numericValue !== 'number' || // not a number
  //     isNaN(numericValue) ||
  //     numericValue <= 0;

  //   if (shouldValidate) {
  //     test("Revenue", "Revenue must be an integer or float and greater than 0.", () => {
  //       enforce(numericValue).number();
  //       enforce(numericValue).greaterThan(0);
  //     });
  //   }
  // }

  // if (content?.popularity) {
  //   const popularityRaw = content?.popularity != null ? content.popularity : null;
  //   const isPopularityNumericString = typeof popularityRaw === 'string' && /^-?\d+(\.\d+)?$/.test(popularityRaw);
  //   const numericPopularity = isPopularityNumericString ? parseFloat(popularityRaw) : popularityRaw;

  //   if (
  //     numericPopularity == null || // null or undefined
  //     typeof numericPopularity === 'string' || // non-numeric strings
  //     isNaN(numericPopularity) || // NaN values
  //     typeof numericPopularity !== 'number' || // Not a number
  //     numericPopularity <= 0 // Not greater than 0
  //   ) {
  //     test("Popularity", "Popularity must be an integer or float and greater than 0.", () => {
  //       enforce(numericPopularity).number();
  //       enforce(numericPopularity).greaterThan(0);
  //     });
  //   }
  // }

  // if (content?.season_numbers && content?.season_numbers?.filter(str => str)?.length === 0) {
  //   test("Season Number", 'Season Field is missing in one of the records of season details.', () => {
  //     const season_numbers = content?.season_numbers; // Incorrect second entry
  //     season_numbers?.forEach((num) => {
  //       expect(isNumber(Number(num)) && isNotEmpty(num)).toBe(true);
  //     })
  //   });
  // }

  if (content?.facebook_url) {
    test("Facebook Url", 'Facebook URL is not valid.', () => {
      const regex = /^https:\/\/([^.]+\.)?facebook\.com(\/[^'"]*)?$/i;
      enforce(content?.facebook_url).matches(regex);
    });
  }
  if (content.instagram_url) {
    test("Instagram Url", 'Instagram URL is not valid.', () => {
      const regex = /^https:\/\/([^.]+\.)?instagram\.com(\/[^'"]*)?$/i;
      enforce(content.instagram_url).matches(regex);
    });
  }
  if (content.twitter_url) {
    test("Twitter Url", 'Twitter URL is not valid.', () => {
      const regex = /^https:\/\/([^.]+\.)?(twitter\.com|x\.com)(\/[^'"]*)?$/i;
      enforce(content.twitter_url).matches(regex);
    });
  }
});


function isDateValid(dateValue) {
  if (dateValue instanceof Date) {
    return !isNaN(dateValue.getTime());
  }
  if (typeof dateValue === 'string') {
    const trimmed = dateValue.trim();
    if (!trimmed || /nan/i.test(trimmed)) {
      return false;
    }
    const date = new Date(trimmed);
    return !isNaN(date.getTime());
  }
  return false;
}

const isNumber = (value) => typeof value === 'number';
const isNotEmpty = (value) => value !== null && value !== undefined && value !== '';